<template>
<div class="image-cropper"
  :class="{
   'image-cropper--moving': moving,
  }">
  <img class="image-cropper_img" ref="image" :src="src">
</div>
</template>

<script>
import Cropper from './../mixins/cropper';

/**
 * ImageCropper
 *
 * uses cropperjs to crop an image in a canvas
 */
export default {
  name: 'image-cropper',
  mixins: [Cropper],
  props: {
    src: {
      type: String,
    }
  }
};
</script>

<style lang="scss">
@import './../assets/styles/cropper';

.image-cropper {
  height: 100%;
  width: 100%;
  position: relative;

  &__img {
    // https://github.com/fengyuanchen/cropperjs

      max-width: 100%;
  }

  .cropper {
    &-modal {
      background-color: $color-background-cropper-modal-base;
      opacity: $number-opacity-cropper-modal-base;
    }
    &-view-box {
      display: block;
      height: 100%;
      outline: none;
      overflow: hidden;
      width: 100%;
      border: $size-border-cropper-view-box solid $color-border-cropper-view-box-base;
      border-radius: $size-border-radius-cropper-view-box;
    }
    &-point {
      opacity: $number-opacity-cropper-point-base;
    }
    &-center {
      opacity: $number-opacity-cropper-center-base;
    }
    &-dashed {
      border-color: $color-border-cropper-dashed-base;
      border-style: solid;
    }
    &-line {
      background-color: $color-background-cropper-line-base;
    }
  }

  &--moving {
    .cropper {
      &-modal {
        opacity: $number-opacity-cropper-modal-moving;
      }
    }
  }

}
</style>
